/**
 * The modules a plan can offer, as shops.offered_modules keys (opt-out: only an
 * explicit false withholds one). What is actually ON is derived from this, the
 * owner's own switches and each module's requirements (backend utils/modules.js
 * is the source of truth). `enforced` says whether the API refuses the feature
 * when it is off, or only stores the flag. One list for the shop screen and the
 * plans screen.
 */
export const MODULES = [
  { key: "finance", label: "Profit tracking (expenses, deliveries, revenue)", enforced: true },
  { key: "suppliers", label: "Suppliers (needs profit tracking)", enforced: true },
  { key: "mixing", label: "Mixing lab (needs profit tracking)", enforced: true },
  { key: "credit_sales", label: "Credit sales", enforced: true },
  { key: "customer_menu", label: "Customer QR menu", enforced: true },
  { key: "preorders", label: "Pre-orders (needs the menu)", enforced: true },
  { key: "offers", label: "Offers & discounts", enforced: true },
  { key: "packs", label: "Packs", enforced: true },
  { key: "cash_drawer", label: "Cash drawer", enforced: true },
  { key: "savings", label: "Savings", enforced: true },
  { key: "reminders", label: "Reminders", enforced: true },
  { key: "journal", label: "Journal", enforced: true },
  { key: "push_notifications", label: "Push notifications", enforced: false },
];

export const MODULE_KEYS = MODULES.map((module) => module.key);
